import { Message, MessageType, CommunicationTool } from '../chat-api';
import moment from 'moment';
import _ from 'lodash';


// Check if it's the last message or if it's the last message of the sender
export const isLastMessage = (index: number, messagesByDate: Message[], message: Message) => {
  return index === messagesByDate.length - 1 || messagesByDate[index + 1].from.user?._id !== message.from.user?._id || messagesByDate[index + 1].type === MessageType.VideoConference;
}

// Check if it's the first message or if it's the first message of the sender
export const isFirstMessage = (index: number, messagesByDate: Message[], message: Message) => {
  return index === 0 || messagesByDate[index - 1].from.user?._id !== message.from.user?._id || messagesByDate[index - 1].type === MessageType.VideoConference;
}

export const getMessagesByDate = (messages: Message[], sendingMessages: Message[]) => {
  sendingMessages = sendingMessages.filter(sndMsg => !messages.find(msg => (msg._id && msg._id === sndMsg._id)
    || (msg.sendHash && msg.sendHash === sndMsg.sendHash)));
  messages = [...messages, ...sendingMessages].sort((msgA, msgB) => {
    return (new Date(msgA.date).getTime()) - (new Date(msgB.date).getTime());
  });
  return _.groupBy(messages, (message: Message) => moment(message.date).format('YYYY-MM-DD'));
}

export const isMsgOut = (message: Message | null, communicationTool: CommunicationTool | null) => {
  return message?.from.user?._id === communicationTool?.user?._id;
}

export const getMediaDuration = (mediaVideo: HTMLVideoElement | HTMLAudioElement | null) => {
  const today = moment().utcOffset(0);
  if (mediaVideo) {
    today.set({ hour: 0, minute: 0, second: mediaVideo.duration, millisecond: 0 })
    if (mediaVideo.duration < 600)
      return today.format('m:ss');
    else if (mediaVideo.duration < 3600)
      return today.format('mm:ss');
    else
      return today.format('hh:mm');
  }
  return '0:00';
}

export const calculateColorCode = (text: any) => {
  if (text == null) {
    return 'S';
  }

  const textString = text.toString();

  /* Garante que "Sydle" sempre terá um fundo preto. */
  if (textString && (textString.trim().toLowerCase() === 'sydle' || textString.trim().toLowerCase() === 's')) {
    return 'S';
  }

  return String.fromCharCode('A'.charCodeAt(0) + (calculateStringHash(textString) % 26));
}

export const calculateStringHash = (str: string) => {
  let hash = 5381,
    i = str.length;

  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}
